import React, { createContext, useContext } from 'react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import cn from '@/utils/cn';

// Where grade sync's routes start inside the router: /support/grade-sync in the SPA, the router's
// root on the legacy /admin/grade_sync mount (admin/GradeSyncHealth), whose BrowserRouter is based there.
const GradeSyncBaseContext = createContext('/support/grade-sync');

export const GradeSyncBaseProvider = GradeSyncBaseContext.Provider;

export const useGradeSyncPath = () => {
  const base = useContext(GradeSyncBaseContext);

  return (path = '') => `${base}${path}` || '/';
};

type GradeSyncLinkProps = Omit<LinkProps, 'to'> & { to: string };

export const linkClass = cn(
  'tw-text-spa-accent-text tw-no-underline',
  'hover:tw-text-spa-accent-text-hover hover:tw-underline',
);

// A Link whose `to` is relative to grade sync's base, so it lands on the same page on either mount.
export const GradeSyncLink = ({ className, to, ...props }: GradeSyncLinkProps) => {
  const gradeSyncPath = useGradeSyncPath();

  return <Link {...props} className={cn(linkClass, className as string)} to={gradeSyncPath(to)} />;
};
